import { render, staticRenderFns } from "./Leisurewear.vue?vue&type=template&id=225d11a6&scoped=true"
import script from "./Leisurewear.vue?vue&type=script&lang=js"
export * from "./Leisurewear.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/inbox.css?vue&type=style&index=0&id=225d11a6&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225d11a6",
  null
  
)

export default component.exports